import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { appContainer } from "../container";
import { UserService } from "../services/userService";
import { DashboardInterface } from "../interface/UserInterface";

export const useDashboardStore = defineStore("dashboard", () => {
  const userService = appContainer.resolve(UserService);

  const dashboardData = ref<DashboardInterface | null>(null);

  async function fetchDashboardData() {
    await userService
      .getDashboardData()
      .then((result) => {
        dashboardData.value = result;
      })
      .catch(() => {
        dashboardData.value = null;
      });
  }

  const pendingAssessmentsCount = computed(() => {
    if (!dashboardData.value?.rater) return 0;
    const total = dashboardData.value.rater.total_feedbacks.data;
    const completed = dashboardData.value.rater.completed_feedbacks.data;
    return Math.max(0, total - completed);
  });

  // Sessions completed recently, as already counted by the dashboard endpoint.
  const completedSessionsCount = computed(
    () =>
      dashboardData.value?.super_admin?.last_week_feedbacks.data ??
      dashboardData.value?.admin?.last_week_feedbacks.data ??
      0,
  );

  return {
    dashboardData,
    fetchDashboardData,
    pendingAssessmentsCount,
    completedSessionsCount,
  };
});
